export const TRUST_CENTER = {
  TITLE: 'Centro de Confianza',
  TOTAL_VISITS: 'Total de visitas',
  INDIVIDUAL_PAGE_VIEWS: 'Vistas de página individual',
  RESOURCE_DOWNLOADS: 'Descargas de recursos',
  SINCE_LAST_WEEK: '% Desde la última semana',
}
